import { useState } from 'react'
import { cn } from '@/lib/cn'

/** Up to two initials from a name, e.g. 'Rusty Gimaev' → 'RG'. */
function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase() || '—'
}

/** A team member's avatar: their photo when available, falling back to initials if absent or broken. */
export default function OwnerAvatar({
  name,
  photoUrl,
  size = 'sm',
}: {
  name: string
  photoUrl: string | null
  size?: 'sm' | 'md'
}) {
  const [broken, setBroken] = useState(false)
  const dim = size === 'md' ? 'w-7 h-7 text-[11px]' : 'w-5 h-5 text-[9px]'
  if (photoUrl && !broken) {
    return <img src={photoUrl} alt="" onError={() => setBroken(true)} className={cn(dim, 'rounded-full object-cover shrink-0')} />
  }
  return (
    <span
      className={cn(dim, 'inline-flex items-center justify-center rounded-full bg-brand-primary/15 text-brand-primary font-semibold shrink-0')}
      aria-hidden
    >
      {initials(name)}
    </span>
  )
}
